import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';

import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';
import BorrowingStatus from '../../shared/BorrowingStatus';

export default class RecentlyReturnedStatus extends BcReactComponent {
  render() {
    return (
      <BorrowingStatus to="/v2/recentlyreturned" currentSection={this.props.currentSection}>
        <SidebarCompactTitle
          title={<FormattedMessage id="section_title_recently_returned" />}
          count={<span>{this.props.totalBorrowingHistory === -1 ? '' : this.props.totalBorrowingHistory}</span>}
          selected={this.props.currentSection} />
      </BorrowingStatus>
    );
  }
}

RecentlyReturnedStatus.propTypes = {
  currentSection: PropTypes.bool,
  totalBorrowingHistory: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedStatus/RecentlyReturnedStatus.jsx